// 1_utils/top_right_position_fixed_components.js
// Exposes window.NAT.utils.positionOfFixedComponent(...): positions a fixed
// component (top/right) relative to a reference element, recalculated on click
// (and optionally mouseenter) of a trigger element.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.positionOfFixedComponent = function positionOfFixedComponent(
	componentWithStyles,
	componentToReadPositionFrom,
	componentToAddListeners,
	componentForTopPadding,
	listenerOnMouseEnter,
) {
	if (!componentWithStyles || !componentToReadPositionFrom || !componentToAddListeners) {
		console.warn("positionOfFixedComponent failed because some required components are missing.");

		return;
	}

	if (listenerOnMouseEnter) {
		componentToAddListeners.addEventListener("mouseenter", function () {
			applyPosition();
		});
	}

	componentToAddListeners.addEventListener("click", function () {
		applyPosition();
	});

	function applyPosition() {
		const topPosition = componentToReadPositionFrom.getBoundingClientRect().bottom;
		const rightPosition =
			window.innerWidth - componentToReadPositionFrom.getBoundingClientRect().right - window.NAT.scrollbarWidth;
		componentWithStyles.style.top = topPosition + "px";
		componentWithStyles.style.right = rightPosition + "px";

		if (componentForTopPadding) {
			const bottomSpaceOfComponent =
				componentForTopPadding.getBoundingClientRect().bottom -
				componentToReadPositionFrom.getBoundingClientRect().bottom;

			componentWithStyles.style.setProperty("--pad-top", bottomSpaceOfComponent + "px");
		}
	}
};
